import { render, staticRenderFns } from "./publish_record_dialog.vue?vue&type=template&id=c6df625c&scoped=true"
import script from "./publish_record_dialog.vue?vue&type=script&lang=js"
export * from "./publish_record_dialog.vue?vue&type=script&lang=js"
import style0 from "./publish_record_dialog.vue?vue&type=style&index=0&id=c6df625c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6df625c",
  null
  
)

export default component.exports